/**
 * Zod schemas for the tag-fallback recommendation endpoint
 * /api/search/tag-fallback
 *
 * Reuses the SearchListing item shape so fallback results are a drop-in
 * continuation of a `/api/search/listings` list.
 */
import { z } from 'zod';
import { SearchListingSchema } from './listings';

export const TagFallbackSuccessResponseSchema = z.object({
  success: z.literal(true),
  listings: z.array(SearchListingSchema),
  // Tags actually searched this page — the client appends these to seenTags for
  // the next fallback request so results keep drifting outward.
  seedTagsUsed: z.array(z.string()),
  seenTags: z.array(z.string()),
  hasMore: z.boolean(),
});

export type TagFallbackSuccessResponse = z.infer<typeof TagFallbackSuccessResponseSchema>;

export const TagFallbackErrorResponseSchema = z.object({
  success: z.literal(false),
  error: z.string(),
});

export type TagFallbackErrorResponse = z.infer<typeof TagFallbackErrorResponseSchema>;

export const TagFallbackResponseSchema = z.discriminatedUnion('success', [
  TagFallbackSuccessResponseSchema,
  TagFallbackErrorResponseSchema,
]);

export type TagFallbackResponse = z.infer<typeof TagFallbackResponseSchema>;
